<p>new-input works!</p>
